import { apiAction, appendQuery } from 'client/redux/apiHelpers';

export const userLog = (types, query) => {
  return apiAction({
    endpoint: appendQuery('/api/user/log', query),
    method: 'GET',
    types,
  });
};
